import {remCalc} from '_themeUtils'

const alertMessage = {
    AlertMessage: {
        baseStyle: {
            errorBox: {
                background: 'color.background.alertBackground.default',
                border: `${remCalc(1)} solid`,
                borderColor: 'color.border.alertBorder.default',
                borderRadius: remCalc(4),
                padding: `0 ${remCalc(20)}`
            },
            errorMessage: {
                textStyle: 'paragraphMd',
                fontWeight: 400,
                color: 'color.text.alertText.default',
                paddingTop: 'spacing.4',
                paddingBottom: 'spacing.4',
            }
        },
    },
}

export default alertMessage
